<template>
  <el-dialog :visible.sync="visible" :title="$t('余额提示')" width="660px" top="12vh" append-to-body custom-class="low-balance-notice" :z-index="40010" :close-on-click-modal="false">
    <span slot="title" class="balance-notice-kicker"><i class="el-icon-info" aria-hidden="true" /> {{ $t('提示') }}</span>
    <div class="balance-notice-content">
      <h2>{{ $t('余额提示') }}</h2>
      <p class="balance-notice-time">{{ $t('时间') }}：{{ checkedAt }}</p>
      <div class="balance-notice-amount"><span>{{ $t('可预报余额') }}</span><strong>{{ formattedBalance }} <small>USD</small></strong><span class="balance-notice-status">{{ insufficient ? $t('余额不足') : $t('余额偏低') }}</span></div>
      <p class="balance-notice-copy">{{ $t('您的可预报余额已低于 50.00 USD，请及时安排充值，避免影响订单预报和货物正常流转，谢谢。') }}</p>
      <p class="balance-notice-note">{{ $t('可用余额不足以支付本次运费时，将无法提交预报。') }}</p>
    </div>
    <span slot="footer"><el-button @click="viewAccount">{{ $t('查看账户') }}</el-button><el-button type="primary" @click="visible = false">{{ $t('知道了') }}</el-button></span>
  </el-dialog>
</template>

<script>
import { availableBalanceForReminder, claimLowBalanceReminder, LOW_BALANCE_THRESHOLD } from '../../../utils/lowBalanceReminder'

export default {
  name: 'LowBalanceNotice',
  props: {
    account: { type: Object, default: () => ({}) },
    ready: { type: Boolean, default: false },
    blocked: { type: Boolean, default: false },
    sessionKey: { type: String, default: '' }
  },
  data () { return { visible: false, checkedAt: '' } },
  computed: {
    amount () { return availableBalanceForReminder(this.account) },
    insufficient () { return this.amount !== null && this.amount <= 0 },
    formattedBalance () { return this.amount === null ? '--' : this.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
  },
  watch: {
    ready () { this.checkReminder() },
    blocked () { this.checkReminder() },
    amount () { this.checkReminder() },
    sessionKey () { this.visible = false; this.checkReminder() }
  },
  mounted () { this.checkReminder() },
  methods: {
    checkReminder () {
      if (this.blocked || !this.sessionKey || this.amount === null || this.amount >= LOW_BALANCE_THRESHOLD) { this.visible = false; return }
      if (!this.ready || this.visible || !claimLowBalanceReminder(this.sessionKey)) return
      this.checkedAt = new Date().toLocaleString('sv-SE', { timeZone: 'Asia/Shanghai', hour12: false })
      this.visible = true
    },
    viewAccount () { this.visible = false; this.$router.push('/transport/fin-accounts') }
  }
}
</script>

<style scoped>
.balance-notice-kicker { display: inline-flex; align-items: center; gap: 6px; color: #1a73e8; font-size: 15px; font-weight: 500; }
.balance-notice-content { color: #3c4043; }
.balance-notice-content h2 { margin: 0; color: #202124; font-size: 25px; line-height: 1.4; font-weight: 600; }
.balance-notice-time { margin: 12px 0 24px; padding-bottom: 22px; border-bottom: 1px solid #e8eaed; color: #80868b; font-size: 13px; }
.balance-notice-amount { display: flex; align-items: center; flex-wrap: wrap; gap: 10px 14px; margin-bottom: 18px; font-size: 14px; }
.balance-notice-amount strong { color: #946218; font-size: 25px; font-weight: 600; font-variant-numeric: tabular-nums; }
.balance-notice-amount small { font-size: 13px; font-weight: 500; }
.balance-notice-status { padding: 3px 9px; border: 1px solid #eedbb8; border-radius: 5px; background: #fff8eb; color: #946218; font-size: 12px; }
.balance-notice-copy { margin: 0; color: #5f6368; font-size: 15px; line-height: 1.9; }
.balance-notice-note { margin: 16px 0 0; color: #80868b; font-size: 13px; line-height: 1.8; }
@media (max-width: 600px) {
  .balance-notice-content h2 { font-size: 22px; }
  .balance-notice-time { margin-bottom: 20px; padding-bottom: 18px; }
  .balance-notice-amount strong { font-size: 23px; }
}
</style>
